import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "asset-view-wrapper" }
const _hoisted_2 = { class: "assets-table-container" }
const _hoisted_3 = { class: "assets-grid-card" }
const _hoisted_4 = { class: "assets-grid-card__header" }
const _hoisted_5 = { class: "assets-grid-title" }
const _hoisted_6 = { class: "assets-grid-title__text" }
const _hoisted_7 = { class: "text-muted small" }
const _hoisted_8 = { class: "assets-grid-controls" }
const _hoisted_9 = ["title"]
const _hoisted_10 = { class: "assets-grid-card__body" }
const _hoisted_11 = {
  key: 0,
  class: "alert alert-danger d-flex align-items-center gap-2 mb-3"
}
const _hoisted_12 = {
  key: 1,
  class: "d-flex align-items-center gap-3 py-3"
}
const _hoisted_13 = { key: 2 }
const _hoisted_14 = { class: "location-thumb" }
const _hoisted_15 = ["src"]
const _hoisted_16 = {
  key: 0,
  class: "text-muted"
}
const _hoisted_17 = { class: "action-buttons" }
const _hoisted_18 = ["title", "onClick"]
const _hoisted_19 = ["title", "onClick"]
const _hoisted_20 = ["title", "onClick"]
const _hoisted_21 = {
  key: 0,
  class: "text-center text-muted py-3"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_DxHeaderFilter = _resolveComponent("DxHeaderFilter")!
  const _component_DxFilterRow = _resolveComponent("DxFilterRow")!
  const _component_DxPaging = _resolveComponent("DxPaging")!
  const _component_DxPager = _resolveComponent("DxPager")!
  const _component_DxColumn = _resolveComponent("DxColumn")!
  const _component_DxDataGrid = _resolveComponent("DxDataGrid")!
  const _component_AssetGroupWithLocationFormModal = _resolveComponent("AssetGroupWithLocationFormModal")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _cache[1] || (_cache[1] = _createElementVNode("div", { class: "assets-grid-title__icon" }, [
              _createElementVNode("i", { class: "bi bi-hdd-rack-fill" })
            ], -1)),
            _createElementVNode("div", null, [
              _createElementVNode("div", _hoisted_6, _toDisplayString(_ctx.$t('aside.menu.pages.assetGroupsWithLocation')), 1),
              _createElementVNode("div", _hoisted_7, _toDisplayString(_ctx.$t('components.assetGroupsWithLocation.subtitle')), 1)
            ])
          ]),
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("button", {
              type: "button",
              class: "assets-toolbar-btn",
              title: _ctx.$t('components.assets.dataGrids.refresh'),
              onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.fetchList && _ctx.fetchList(...args)))
            }, [
              _cache[2] || (_cache[2] = _createElementVNode("i", { class: "bi bi-arrow-clockwise" }, null, -1)),
              _createElementVNode("span", null, _toDisplayString(_ctx.$t('components.assets.dataGrids.refresh')), 1)
            ], 8, _hoisted_9)
          ])
        ]),
        _createElementVNode("div", _hoisted_10, [
          (_ctx.listError)
            ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                _cache[3] || (_cache[3] = _createElementVNode("i", { class: "bi bi-exclamation-triangle-fill" }, null, -1)),
                _createElementVNode("span", null, _toDisplayString(_ctx.listError), 1)
              ]))
            : _createCommentVNode("", true),
          (_ctx.listLoading)
            ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                _cache[4] || (_cache[4] = _createElementVNode("span", {
                  class: "spinner-border text-primary",
                  role: "status"
                }, null, -1)),
                _createElementVNode("span", null, _toDisplayString(_ctx.$t('components.assetGroupsWithLocation.loading')), 1)
              ]))
            : (_openBlock(), _createElementBlock("div", _hoisted_13, [
                _createVNode(_component_DxDataGrid, {
                  class: "agwl-grid",
                  "data-source": _ctx.listData,
                  "hover-state-enabled": true,
                  "column-auto-width": false,
                  "show-borders": false,
                  "show-column-lines": false,
                  "show-row-lines": false,
                  "row-alternation-enabled": true,
                  "row-rendering-mode": 'standard',
                  "column-hiding-enabled": true,
                  "word-wrap-enabled": true
                }, {
                  "location-image": _withCtx(({ data }) => [
                    _createElementVNode("div", _hoisted_14, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(data.data.locationImages, (img, idx) => {
                        return (_openBlock(), _createElementBlock("img", {
                          key: idx,
                          src: img,
                          alt: "Location thumbnail",
                          class: "location-thumb__img"
                        }, null, 8, _hoisted_15))
                      }), 128)),
                      (!data.data.locationImages?.length)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_16, "-"))
                        : _createCommentVNode("", true)
                    ])
                  ]),
                  "actions-template": _withCtx(({ data }) => [
                    _createElementVNode("div", _hoisted_17, [
                      (!_ctx.isReadOnly)
                        ? (_openBlock(), _createElementBlock("button", {
                            key: 0,
                            type: "button",
                            class: "btn btn-sm btn-outline-primary",
                            title: _ctx.$t('components.assetGroupsWithLocation.actions.edit'),
                            onClick: ($event: any) => (_ctx.openEditModal(data.data))
                          }, [...(_cache[5] || (_cache[5] = [
                            _createElementVNode("i", { class: "bi bi-pencil" }, null, -1)
                          ]))], 8, _hoisted_18))
                        : _createCommentVNode("", true),
                      (_ctx.canEdit)
                        ? (_openBlock(), _createElementBlock("button", {
                            key: 1,
                            type: "button",
                            class: "btn btn-sm btn-outline-danger",
                            title: _ctx.$t('components.assetGroupsWithLocation.actions.delete'),
                            onClick: ($event: any) => (_ctx.confirmDelete(data.data))
                          }, [...(_cache[6] || (_cache[6] = [
                            _createElementVNode("i", { class: "bi bi-trash" }, null, -1)
                          ]))], 8, _hoisted_19))
                        : _createCommentVNode("", true),
                      (_ctx.isReadOnly)
                        ? (_openBlock(), _createElementBlock("button", {
                            key: 2,
                            type: "button",
                            class: "btn btn-sm btn-outline-secondary",
                            title: _ctx.$t('components.assetGroupsWithLocation.actions.view'),
                            onClick: ($event: any) => (_ctx.openViewModal(data.data))
                          }, [...(_cache[7] || (_cache[7] = [
                            _createElementVNode("i", { class: "bi bi-eye" }, null, -1)
                          ]))], 8, _hoisted_20))
                        : _createCommentVNode("", true)
                    ])
                  ]),
                  default: _withCtx(() => [
                    _createVNode(_component_DxHeaderFilter, { visible: true }),
                    _createVNode(_component_DxFilterRow, { visible: true }),
                    _createVNode(_component_DxPaging, { "page-size": 20 }),
                    _createVNode(_component_DxPager, {
                      "allowed-page-sizes": [10, 20, 50],
                      "show-info": true,
                      "show-page-size-selector": true,
                      "show-navigation-buttons": true
                    }),
                    _createVNode(_component_DxColumn, {
                      "data-field": "name",
                      caption: _ctx.$t('components.assetGroupsWithLocation.columns.name'),
                      "min-width": 180
                    }, null, 8, ["caption"]),
                    _createVNode(_component_DxColumn, {
                      "data-field": "locationImages",
                      caption: _ctx.$t('components.assetGroupsWithLocation.columns.locationImage'),
                      width: "160",
                      "allow-filtering": false,
                      "allow-sorting": false,
                      "cell-template": "location-image",
                      alignment: "center",
                      "hiding-priority": 2
                    }, null, 8, ["caption"]),
                    _createVNode(_component_DxColumn, {
                      "data-field": "schemesCount",
                      caption: _ctx.$t('components.assetGroupsWithLocation.columns.schemesCount'),
                      alignment: "center",
                      width: "140",
                      "allow-filtering": false,
                      "hiding-priority": 3
                    }, null, 8, ["caption"]),
                    _createVNode(_component_DxColumn, {
                      "data-field": "locationText",
                      caption: _ctx.$t('components.assetGroupsWithLocation.columns.location'),
                      "min-width": 160,
                      alignment: "center",
                      "allow-filtering": false,
                      "hiding-priority": 1
                    }, null, 8, ["caption"]),
                    _createVNode(_component_DxColumn, {
                      caption: _ctx.$t('components.assetGroupsWithLocation.columns.actions'),
                      width: 150,
                      "allow-filtering": false,
                      "allow-sorting": false,
                      "cell-template": "actions-template",
                      "hiding-priority": 4
                    }, null, 8, ["caption"])
                  ]),
                  _: 1
                }, 8, ["data-source"]),
                (!_ctx.listData.length)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_21, _toDisplayString(_ctx.$t('components.assetGroupsWithLocation.empty')), 1))
                  : _createCommentVNode("", true)
              ]))
        ])
      ])
    ]),
    _createVNode(_component_AssetGroupWithLocationFormModal, {
      ref: "formModal",
      onSaved: _ctx.handleSaved
    }, null, 8, ["onSaved"])
  ]))
}